import { render, staticRenderFns } from "./liveReview.vue?vue&type=template&id=cd05fcf6"
import script from "./liveReview.vue?vue&type=script&lang=js"
export * from "./liveReview.vue?vue&type=script&lang=js"
import style0 from "./liveReview.vue?vue&type=style&index=0&id=cd05fcf6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports